<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="批量操作"
    :visible.sync="dialogVisible"
    width="1000px"
    :before-close="cancel"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="5%"
  >
    <div class="muti-container">
      <p style="color: #f56c6c">
        <i class="el-icon-warning"></i>
        不支持上传已完结提单文件
      </p>
      <p style="color: #f56c6c">
        <i class="el-icon-warning"></i>
        文件命名规范：提单号-类型-备注（可以没有备注）类型代码：AN/DO/BL(提单)/7501(税金单)/INV(提单发票)
      </p>
      <p style="color: #f56c6c">
        &nbsp;&nbsp;&nbsp; 举例：EGLV12345678-BL &nbsp;&nbsp;&nbsp;&nbsp;
        EGLV12345678-DO-123
      </p>
      <!-- :action="`/api/SystemFile/uploadMBLFileDirectly?type=${form.type}`" -->
      <div v-if="tableData.columns.length === 0" class="upload">
        <el-upload
          class="upload-demo"
          drag
          :headers="headers"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          multiple
          :on-change="handleOnChange"
        >
          <svg-icon
            style="color: rgb(18, 88, 188)"
            iconClass="upload"
            className="icon"
          />
          <p class="p1">拖拽你的文件到此处</p>
          <p class="p2">或</p>
          <div class="btn">点击上传</div>
        </el-upload>
      </div>

      <BaseTable v-else :height="500" :tableData="tableData" :isPager="false">
        <template slot="errorMessage" slot-scope="row">
          <el-tooltip
            v-if="row.scope.errorMessage"
            class="item"
            effect="light"
            :content="row.scope.errorMessage"
            placement="right"
          >
            <i class="el-icon-warning-outline" style="color: #f56c6c" />
          </el-tooltip>
        </template>
      </BaseTable>
    </div>
    <div v-if="tableData.columns.length" class="footer">
      <el-button class="btn btn-defalut" @click="cancel">取 消</el-button>
      <el-button class="btn btn-primary" @click="ok">确定上传</el-button>
    </div>
  </el-dialog>
</template>

<script>
import config from '@/utils/config'
import { validateFileName, uploadMBLFile } from '@/api/system'
const BaseTable = () => import('@/components/table/BaseTable')
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      config,
      tableData: {
        fileds: [
          {
            filed: 'errorMessage',
            label: '错误信息',
            isCustom: true
          },
          {
            filed: 'mblNo',
            label: '提单号'
          },
          {
            filed: 'containerNo',
            label: '柜号'
          },
          {
            filed: 'fileName',
            label: '文件名'
          },
          {
            filed: 'fileType',
            label: '上传类型',
            formatter: (row) => {
              return config.fileTypeOption.find((a) => a.value === row.fileType)
                ?.label
            }
          },
          {
            filed: 'extension',
            label: '文件类型'
          },
          {
            filed: 'remark',
            label: '备注'
          }
        ],
        columns: [],
        total: 0
      },
      fileList: [],
      debounceTimer: null,
      loading: false,
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.fileList = []
        this.tableData.columns = []
      }
    }
  },
  beforeDestroy() {
    // 清除定时器防止内存泄漏
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    ok() {
      if (!this.tableData.columns.length) {
        this.$message.error('请选择文件')
        return
      }
      const items = this.tableData.columns.filter((a) => !a.errorMessage)
      if (!items.length) {
        this.$message.error('请选择正确的文件')
        return
      }
      this.loading = true
      const promise = items.map(async(item) => {
        let result
        const file = this.fileList.find((a) => a.name === item.sourceFileName)
        const formData = new FormData()
        formData.append('file', file.raw)
        formData.append('mblId', item.mblId)
        formData.append('remark', item.remark)
        formData.append('uploadType', item.fileType)
        try {
          result = await uploadMBLFile(formData)
        } catch (error) {
          console.error(error)
        }
        return new Promise((resolve) => {
          resolve(result)
        })
      })
      Promise.all(promise).then((res) => {
        this.loading = false
        console.log(res)
        let str = ''
        res.forEach((a) => {
          if (!a.data.success) {
            str += a.data.errorMessage + ';'
          }
        })
        if (str) {
          this.$message.error(str)
        } else {
          this.$message.success('上传成功')
          this.$emit('cancel')
        }
      })
    },
    handleOnChange(file, fileList) {
      // 更新文件列表
      this.fileList = fileList
      // 清除之前的定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      // 设置新的定时器
      this.debounceTimer = setTimeout(() => {
        this.processFiles(fileList)
      }, 500) // 延迟500毫秒执行
    },
    async processFiles(fileList) {
      // 这里可以添加实际的文件处理逻辑
      console.log('处理文件:', fileList)
      try {
        this.loading = true
        const res = await validateFileName(fileList.map((item) => item.name))
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.muti-container {
  width: 100%;
  height: auto;
  margin: 0 auto;
  .muban {
    width: 100%;
    height: 179px;
    background: #f8fbff;
    border-radius: 6px 6px 6px 6px;
    padding: 14px 32px 32px;
    opacity: 1;
    border: 1px dashed #dbe4f2;
    box-sizing: border-box;
    margin: 0 auto;
    .download-content {
      display: flex;
      width: 100%;
    }
    span {
      display: inline-block;
      width: 100%;
      height: 40px;
      font-size: 14px;
      font-weight: 400;
      color: #f56c6c;
      line-height: 40px;
      margin-right: 14px;
    }
    .icon {
      font-size: 20px;
      vertical-align: text-top;
      margin-left: 4px;
    }
    .btn {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #7c8db5;
      line-height: 24px;
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }
  .upload {
    width: 100%;
    height: 320px;
    background: #f8fbff;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    margin: 0 auto;
    margin-top: 16px;
    .icon {
      font-size: 80px;
      margin: 48px auto 0;
    }
    .p1 {
      height: 19px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #25396f;
      line-height: 24px;
      text-align: center;
      margin-top: 32px;
    }
    .p2 {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #25396f;
      line-height: 24px;
      text-align: center;
      margin-top: 16px;
    }
    .btn {
      width: 120px;
      height: 40px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid rgb(18, 88, 188);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      line-height: 40px;
      text-align: center;
      margin: 16px auto 0;
    }
    /deep/ .upload-demo {
      width: 100%;
      height: 100%;
    }
    /deep/.el-upload {
      width: 100%;
      height: 100%;
    }
    /deep/.el-upload-dragger {
      width: 100%;
      height: 100%;
    }
    /deep/.el-upload-dragger {
      background: #f8fbff;
    }
  }
}
.upload-res {
  width: 100%;
  height: auto;
}
.footer {
  text-align: center;
  margin-top: 24px;
  .btn {
    width: 160px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    cursor: pointer;
    & + .btn {
      margin-left: 16px;
    }
  }
  .btn-defalut {
    border: 1px solid #dbe4f2;
    color: #7c8db5;
    background: #f2f7ff;
  }
  .btn-primary {
    background: rgb(18, 88, 188);
    color: #ffffff;
  }
}
/deep/ .el-dialog__header {
  border: 0;
}
/deep/ .el-dialog__body {
  padding-top: 4px;
}
/deep/ .el-tooltip__popper.is-light {
  color: #f56c6c;
}
</style>
